import React from 'react'

function MidContent() {
    return (
        <div className="midcontent">
            <div className="users-record">
                <h1>5k+</h1>
                <p style={{marginBottom:"0", color:"#2E3192"}}>Users</p>
            </div>
            <div className="users-record">
                <h1>4k+</h1>
                <p style={{marginBottom:"0", color:"#2E3192"}}>Interviews</p>
            </div>
            <div className="users-record">
                <h1>3k+</h1>
                <p style={{marginBottom:"0", color:"#2E3192"}}>Jobs secured</p>
            </div>
        </div>
    )
}

export default MidContent
